<template>
  <div>
    <el-form
      :model="formParams"
      class="elFormClass"
      ref="ruleForm"
      label-width="auto"
      size="small"
    >
      <el-form-item
        v-for="item in formItem"
        :key="item.model"
        :label="item.label"
        :prop="item.model"
        :rules="formRules.requiredChange"
      >
        <el-select
        clearable
          @change="selectChange"
          style="width:99%"
          v-model="formParams[item.model]"
          v-if="item.model == 'formLabel'"
          :placeholder="'请选择' + item.label"
        >
          <el-option
            v-for="op in item.options"
            :key="op.model"
            :label="op.label"
            :value="op.model"
          >
          </el-option>
        </el-select>
        <el-input
        clearable
          :placeholder="'请输入' + item.label"
          v-model="formParams[item.model]"
          v-else
        ></el-input>
      </el-form-item>
      <el-form-item
        :rules="formRules.requiredChange"
        v-if="formParams.formLabel == 'select'"
        label="选择配置"
      >
        <el-form-item
          :rules="formRules.requiredChange"
          :prop="`selectDatas[${sindex}]`"
          v-for="(i, sindex) in formParams.selectDatas"
          :key="sindex"
        >
          <div class="flex_between_nowrap">
            <el-input
            clearable
              style="flex:1"
              :placeholder="'请输入选择配置' + (sindex + 1)"
              v-model="formParams.selectDatas[sindex]"
            ></el-input>
            <span class="add_icon" @click="selectData(sindex)"
              ><i
                :class="
                  sindex === 0 ? 'iconfont icon-hao' : 'iconfont icon-jianhao'
                "
              ></i
            ></span>
          </div>
        </el-form-item>
      </el-form-item>
      <el-form-item
        label="是否必填"
        prop="whetherRequired"
        :rules="formRules.requiredChange"
      >
        <el-checkbox
          v-model="formParams['whetherRequired']"
          :true-label="1"
          :false-label="0"
          >是</el-checkbox
        >
        <el-checkbox
          v-model="formParams['whetherRequired']"
          :true-label="0"
          :false-label="1"
          >否</el-checkbox
        >
      </el-form-item>
    </el-form>
    <div class="dialog_bottom">
      <el-button class="dialog_close" size="small" @click="closeDialog"
        >取 消</el-button
      >
      <el-button
        class="dialog_submit"
        size="small"
        style="width:100px"
        type="submit"
        @click="submit"
        >确 定</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    callBack: Function,
    templateId: String,
    row:Object,
    id:String,
  },
  data() {
    return {
      formParams: {
        formLabel: "",
        whetherRequired: 1,
       
      },
      formItem: [
        {
          label: "属性名称",
          model: "formTitle",
        },
        {
          label: "属性值类型",
          model: "formLabel",
          options: [
            {
              label: "文本",
              model: "text",
            },
            {
              label: "选择",
              model: "select",
            },
            {
              label: "时间",
              model: "time",
            },
          ],
        },
      ],
    };
  },
  mounted() {},
  methods: {
    init(){
      if(this.row.id){
        this.formParams=Object.assign({},this.row)
        if(this.formParams.whetherRequired){
          this.$set(this.formParams,'whetherRequired',1)
        }else{
          this.$set(this.formParams,'whetherRequired',0)

        }
      }else{
        this.formParams.templateId=this.templateId
      }
    },
    submit() {
      this.$formValidate(this, "ruleForm").then(() => {
        this.$requestAxiosForm(
          {
            url: "/pc/template/form/add_update",
            data: this.formParams,
          },
          (data) => {
            this.$success();
            this.closeDialog();
            this.callBack();
          }
        );
      });
    },
    selectData(index) {
      if (index == 0) {
        this.formParams.selectDatas.push("");
      } else {
        this.formParams.selectDatas.splice(index, 1);
      }
    },
    selectChange(data) {
      if (data == "select") {
        this.$set(this.formParams, "selectDatas", [""]);
      } else {
        this.$set(this.formParams, "selectDatas", "");
      }
    },
  },
};
</script>

<style scoped>
.add_icon {
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  display: inline-block;
  color: #fff;
  background-color: #436bff;
  border-radius: 4px;
  margin-left: 8px;
}
</style>
